import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Combina condicionalmente clases de Tailwind.
 * Usa clsx + tailwind-merge para evitar clases duplicadas.
 *
 * @example
 * cn("p-4", condition && "bg-blue-500")
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Une múltiples referencias (refs) en una sola ref.
 * Útil cuando un componente interno y externo necesitan el mismo ref.
 *
 * @example
 * const combinedRef = mergeRefs([refA, refB])
 * <input ref={combinedRef} />
 */
export function mergeRefs(refs) {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value)
      } else if (ref != null) {
        ref.current = value
      }
    })
  }
}

/**
 * Formatea una fecha a un formato legible.
 * Usa Intl.DateTimeFormat.
 *
 * @example
 * formatDate("2025-10-06") → "06 Oct 2025"
 */
export function formatDate(date, locale = "es-ES") {
  if (!date) return ""
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(date))
}

/**
 * Convierte valores null/undefined en string vacío (útil para inputs controlados)
 */
export function safeValue(value) {
  return value ?? ""
}
